import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";

import { notificationConfig } from "../../../config/ui/notifications/notification-config";

import App from "./App";
import { ThemeProvider } from "./components/ThemeProvider";
import "./index.css";
import "../../../config/ui/theme/theme-styles.css";

// Create a query client instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        {/* TODO: React Router v7 Migration - Add future flags to BrowserRouter:
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            See: https://reactrouter.com/v6/upgrading/future */}
        <BrowserRouter>
          <ThemeProvider defaultMode="system">
            <Toaster
              position={notificationConfig.position}
              toastOptions={{
                duration: notificationConfig.duration,
                style: notificationConfig.baseStyle,
              }}
            />
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
